import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ClientService {
	private url = environment.api;
	constructor(
		private http: HttpClient,
	) { }

	getClientsByClue(clue: string) {
		return this.http.get(this.url + "api/erp/inventory/vendor/search/existing",
			{
				params: {
					clue: clue,
					client: true,
					provider: false
				}
			}
		);
	}

	getCF() {
		return this.http.get(this.url + "api/erp/inventory/vendor/search/cf/vendor");
	}

	getAllClientsFromDepartmentAndTown(department: number, kindPerson: number, limit: number, town: number, warehouse: number) {
		return this.http.get(this.url + "api/erp/inventory/vendor/search/sat/all?" + `department=${department}&kindPerson=${kindPerson}&limit=${limit}&town=${town}&warehouse=${warehouse}`);
	}
}
